var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.843 11.916c.386-.386 1.009-.386 1.395 0l2.306 2.305 5.877-5.876c.385-.386 1.008-.386 1.394 0 .386.386.386 1.009 0 1.394l-6.577 6.574c-.192.192-.444.289-.697.289-.253 0-.506-.097-.698-.289L6.84 13.31c-.383-.383-.383-1.008.003-1.394M12 24c6.616 0 12-5.384 12-12S18.616 0 12 0 0 5.384 0 12s5.384 12 12 12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledCheck);
export default __webpack_public_path__ + "static/media/filled-check.487f2f82f8c193d50680595fff280164.svg";
export { ForwardRef as ReactComponent };